import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import MxAutoCompleteField from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";

import { useMxFieldControllerContext } from "@rf/context/MxFieldController";

type omit =
  | "value"
  | "onChange"
  | "onBlur"
  | "name"
  | "id"
  | "inputRef"
  | "testId"
  | "error";

export type MxFormAutoCompleteFieldProps = Omit<MxAutoCompleteFieldProps, omit>;
const MxFormAutoCompleteField = (props: MxFormAutoCompleteFieldProps) => {
  const { onChange, onBlur, name, value, invalid, id, inputRef, testId } =
    useMxFieldControllerContext();

  const handleChange = (e: any) => {
    onChange({ ...e });
  };
  return (
    <MxAutoCompleteField
      {...props}
      id={id}
      testId={testId}
      ref={inputRef}
      onChange={handleChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormAutoCompleteField;
